import $ from 'jquery';

class LiveChat {
    constructor() {
        this.listeners();
    }

    listeners() {
        this.loadLiveChatMessages();
    }

    loadLiveChatMessages() {
        let liveChat = $('#live-chat');
        if (liveChat.length === 0) {
            return;
        }

        const videoId = liveChat.data('video-id');
        fetch(`/wp-json/live-api/v1/get-yt-livechat/${videoId}`)
            .then(response => response.json())
            .then(data => {
                if (!data.live)
                    return;

                let chat = '';
                data.content.items.map(item => {
                    const publishedAt = new Date(item.snippet.publishedAt).toLocaleTimeString();

                    let message = '<div class="row"><div class="col-12">';
                    message += `<div class="livechat livechat-heading">${publishedAt}  -  ${item.authorDetails.displayName}</div>`;
                    message += '</div></div>';
                    message += '<div class="row"><div class="col-12 mb-4">';
                    message += `<div class="livechat livechat-content">${item.snippet.displayMessage}</div>`;
                    message += '</div></div>';
                    chat = message + chat;
                });
                chat = `<div class="content">${chat}</div>`;
                liveChat.html(chat);

                setTimeout(() => this.loadLiveChatMessages(), 5000);
            })
            .catch((err) => console.error(err));
    }
}

export default LiveChat;
